export default "__VITE_ASSET__Mb35SVfS__"